import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

interface PhotoLogEntry {
  id: string;
  timestamp: Date;
  licensePlate: string;
  location: string;
  direction: 'entry' | 'exit';
  cameraId: string;
  confidence: number;
  photoUrl?: string;
}

@Component({
  selector: 'app-photo-log',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './photo-log.component.html',
  styleUrl: './photo-log.component.scss'
})
export class PhotoLogComponent implements OnInit {
  photoLog: PhotoLogEntry[] = [];
  loading = false;
  displayedColumns: string[] = ['timestamp', 'licensePlate', 'direction', 'location', 'camera', 'confidence', 'actions'];

  ngOnInit(): void {
    this.loadPhotoLog();
  }

  loadPhotoLog(): void {
    this.loading = true;
    
    // Демо дані - журнал фотофіксації
    const licensePlates = ['AA 1234 BB', 'KA 5678 XX', 'AI 9876 CM', 'BC 2468 KK', 'AO 1357 OI', 'KI 8642 AX'];
    const locations = ["В'їзд Головний", "Виїзд Головний", "В'їзд Бічний", "Виїзд Бічний"];
    
    this.photoLog = Array.from({ length: 20 }, (_, i) => ({
      id: `log-${i}`,
      timestamp: new Date(Date.now() - i * 15 * 60 * 1000), // Кожні 15 хвилин
      licensePlate: licensePlates[Math.floor(Math.random() * licensePlates.length)],
      location: locations[Math.floor(Math.random() * locations.length)],
      direction: Math.random() > 0.5 ? 'entry' : 'exit',
      cameraId: `CAM-${Math.floor(Math.random() * 6) + 1}`,
      confidence: Math.floor(Math.random() * 20) + 80 // 80-100%
    }));

    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  getDirectionIcon(direction: string): string {
    return direction === 'entry' ? 'arrow_forward' : 'arrow_back';
  }

  getDirectionText(direction: string): string {
    return direction === 'entry' ? "В'їзд" : "Виїзд";
  }

  getDirectionClass(direction: string): string {
    return direction === 'entry' ? 'direction-entry' : 'direction-exit';
  }

  viewPhoto(entry: PhotoLogEntry): void {
    console.log('View photo for', entry);
    // Тут буде логіка відображення фото
  }

  downloadPhoto(entry: PhotoLogEntry): void {
    console.log('Download photo for', entry);
    // Тут буде логіка завантаження фото
  }
}
